module.exports = __webpack_public_path__ + "10c3196d53ef1dc62700608e4f86595c.svg";